import supabase from '../supabase/supabase';

const CACHE_MS = 60000;
let cachedLinks;
let cachedAt = 0;
let pending;

// A shared request serves both cards. Redirect pages always request fresh data.
export const getAppStoreLinks = ({ fresh = false } = {}) => {
  if (!fresh && cachedLinks && Date.now() - cachedAt < CACHE_MS) {
    return Promise.resolve(cachedLinks);
  }
  if (pending) return pending;
  pending = (async () => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const { data, error } = await supabase
        .from('app_store_links')
        .select('audience,platform,url,is_available')
        .abortSignal(controller.signal);
      if (error) throw new Error('Unable to load app downloads.');
      cachedLinks = data || [];
      cachedAt = Date.now();
      return cachedLinks;
    } finally {
      clearTimeout(timeout);
      pending = null;
    }
  })();
  return pending;
};
